import { Skeleton, Stack } from "@mui/material";
import { PropsWithChildren } from "react";
import InterviewPageLayout from "./layouts/InterviewPageLayout";

export default function InterviewSkeletonWrapper({ children }: PropsWithChildren) {
	return (
		<InterviewPageLayout>
			<Stack direction="row" justifyContent="space-between">
				<Stack direction="row" spacing="15px" alignItems="center">
					<Skeleton width={64} height={30} />
					<Skeleton width={300} height={22.5} />
				</Stack>
				<Stack direction="row" gap="15px">
					<Stack direction="row" spacing="5px" alignItems="center">
						<Skeleton variant="circular" width={14} height={14} />
						<Skeleton width={100} height={24} />
					</Stack>
				</Stack>
			</Stack>

			{children}
		</InterviewPageLayout>
	);
}
